var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-flex",
    [
      _c("Subheader", {
        attrs: { title: "Aquarius servers Status", "no-search": "" },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-list",
            { attrs: { "two-line": "", subheader: "" } },
            [
              _c(
                "v-list-tile",
                [
                  _c(
                    "v-list-tile-avatar",
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "icon_border",
                          attrs: {
                            color: _vm.status_icons[_vm.NgStatus].theme,
                          },
                        },
                        [_vm._v(_vm._s(_vm.status_icons[_vm.NgStatus].icon))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    [
                      _c("v-list-tile-title", [_vm._v("Aquarius NG")]),
                      _vm._v(" "),
                      _c("v-list-tile-sub-title", [
                        _vm._v(_vm._s(_vm.NgStatus)),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }